import Vue from 'vue';
import VueRouter from 'vue-router';
import Entry from '../views/Entry.vue';
import Report from '../views/Report.vue';

Vue.use(VueRouter);

const routes: any = [
    {
        path: '/report/:report/:accessCode',
        name: 'reportWithAccessCode',
        component: Report,
    },
    {
        path: '/',
        name: 'widget',
        component: Entry,
    },
    {
        path: '/:form',
        name: 'widgetNoAccessCode',
        component: Entry,
    },
    {
        path: '/:form/:accessCode',
        name: 'widgetWithAccessCode',
        component: Entry,
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
});

export default router;
